(function () {
  var COLOUR_MAP = [
    { g: 'black',  t: ['ebony', 'onyx', 'jet', 'carbon', 'noir', 'raven', 'shadow', 'black'] },
    { g: 'white',  t: ['ivory', 'pearl', 'snow', 'bone', 'chalk', 'cream', 'vanilla', 'frost', 'white'] },
    { g: 'grey',   t: ['charcoal', 'gunmetal', 'heather', 'silver', 'slate', 'smoke', 'ash', 'steel', 'grey', 'gray'] },
    { g: 'red',    t: ['crimson', 'scarlet', 'burgundy', 'maroon', 'garnet', 'cherry', 'ruby', 'wine', 'brick', 'tomato', 'red'] },
    { g: 'pink',   t: ['fuchsia', 'magenta', 'flamingo', 'bubblegum', 'blush', 'salmon', 'shell', 'sheel', 'rose', 'pink'] },
    { g: 'orange', t: ['tangerine', 'terracotta', 'terra cotta', 'apricot', 'ginger', 'pumpkin', 'copper', 'coral', 'rust', 'peach', 'orange'] },
    { g: 'yellow', t: ['sunflower', 'mustard', 'canary', 'golden', 'amber', 'honey', 'gold', 'lemon', 'butter', 'yellow'] },
    { g: 'green',  t: ['emerald', 'forest', 'avocado', 'hunter', 'jungle', 'olive', 'khaki', 'sage', 'moss', 'army', 'lime', 'pine', 'fern', 'green'] },
    { g: 'blue',   t: ['coastal', 'tidal', 'midnight', 'sapphire', 'cobalt', 'pacific', 'indigo', 'denim', 'azure', 'marine', 'ocean', 'royal', 'powder', 'sky', 'aqua', 'navy', 'blue'] },
    { g: 'purple', t: ['lavender', 'amethyst', 'orchid', 'eggplant', 'violet', 'plum', 'lilac', 'mauve', 'grape', 'berry', 'purple'] },
    { g: 'brown',  t: ['chocolate', 'espresso', 'mahogany', 'chestnut', 'walnut', 'caramel', 'toffee', 'mocha', 'coffee', 'taupe', 'camel', 'tan', 'brown'] },
    { g: 'beige',  t: ['oatmeal', 'natural', 'wheat', 'stone', 'sand', 'nude', 'latte', 'beige'] },
    { g: 'teal',   t: ['turquoise', 'aquamarine', 'seafoam', 'lagoon', 'caribbean', 'cyan', 'mint', 'teal'] },
    { g: 'multi',  t: ['tie-dye', 'tie dye', 'multicolour', 'multicolor', 'floral', 'plaid', 'stripe', 'check', 'pattern', 'print', 'multi'] }
  ];

  function colourGroup(name) {
    var n = (name || '').toLowerCase().trim().replace(/-/g, ' ');
    for (var i = 0; i < COLOUR_MAP.length; i++) {
      var terms = COLOUR_MAP[i].t;
      for (var j = 0; j < terms.length; j++) {
        if (n.indexOf(terms[j]) !== -1) return COLOUR_MAP[i].g;
      }
    }
    return n;
  }

  function dedupe(card) {
    var picker = card.querySelector('swatches-variant-picker-component');
    if (picker) {
      var seen = {};
      picker.querySelectorAll('li.variant-option__swatch').forEach(function (li) {
        var input = li.querySelector('input[type="radio"]');
        var name = input ? (input.getAttribute('aria-label') || '') : '';
        var g = colourGroup(name);
        if (seen[g]) {
          li.style.display = 'none';
          if (input) input.disabled = true;
        } else {
          seen[g] = true;
        }
      });
    }

    var dotsWrap = card.querySelector('.price-block__swatches');
    if (dotsWrap) {
      var seen2 = {};
      dotsWrap.querySelectorAll('.price-block__swatch-dot').forEach(function (dot) {
        var title = (dot.getAttribute('title') || '').toLowerCase().trim();
        if (seen2[title]) {
          dot.parentNode.removeChild(dot);
        } else {
          seen2[title] = true;
        }
      });
    }

    var countEl = card.querySelector('.price-block__color-count');
    if (countEl) {
      var remainingDots = dotsWrap ? dotsWrap.querySelectorAll('.price-block__swatch-dot').length : 0;
      var remainingSwatches = picker
        ? [].filter.call(picker.querySelectorAll('li.variant-option__swatch'), function (li) {
            return li.style.display !== 'none';
          }).length
        : 0;
      var n = remainingDots || remainingSwatches;
      if (n > 0) {
        countEl.textContent = 'Available in ' + n + ' colour' + (n !== 1 ? 's' : '');
      }
    }
  }

  function setupFilterGrouping() {
    document.querySelectorAll('ul[name="Colour"], ul[name="Color"]').forEach(function (filterList) {
      var allItems = [];
      filterList.querySelectorAll('li.facets__inputs-list-item').forEach(function (li) {
        var input = li.querySelector('input[type="checkbox"]');
        if (!input) return;
        var name = input.getAttribute('aria-label') || input.value || '';
        if (!name) return;
        allItems.push({ li: li, input: input, name: name, group: colourGroup(name) });
      });

      var groups = {};
      allItems.forEach(function (item) {
        if (!groups[item.group]) groups[item.group] = [];
        groups[item.group].push(item);
      });

      Object.keys(groups).forEach(function (g) {
        var members = groups[g];
        if (members.length <= 1) return;

        var rep = null;
        for (var i = 0; i < members.length; i++) {
          if (members[i].name.toLowerCase() === g) { rep = members[i]; break; }
        }
        if (!rep) {
          rep = members.slice().sort(function (a, b) { return a.name.length - b.name.length; })[0];
        }

        var subs = members.filter(function (m) { return m !== rep; });

        subs.forEach(function (sub) { sub.li.style.display = 'none'; });

        if (subs.some(function (s) { return s.input.checked; }) && !rep.input.checked) {
          rep.input.checked = true;
        }

        rep.input.addEventListener('change', function (e) {
          e.stopImmediatePropagation();

          var isChecked = rep.input.checked;
          var paramName = rep.input.name;
          var url = new URL(window.location.href);
          var current = url.searchParams.getAll(paramName);
          var groupVals = [rep.input.value].concat(subs.map(function (s) { return s.input.value; }));

          url.searchParams.delete(paramName);
          url.searchParams.delete('page');

          current.forEach(function (v) {
            if (groupVals.indexOf(v) === -1) url.searchParams.append(paramName, v);
          });

          if (isChecked) {
            groupVals.forEach(function (v) { url.searchParams.append(paramName, v); });
          }

          window.location.href = url.toString();
        });
      });
    });
  }

  function run(root) {
    root.querySelectorAll('product-card').forEach(dedupe);
  }

  function init() {
    run(document);
    setupFilterGrouping();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var observer = new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('product-card')) {
          dedupe(node);
        } else if (node.querySelectorAll) {
          node.querySelectorAll('product-card').forEach(dedupe);
        }
      });
    });
  });

  var list = document.querySelector('results-list, .product-grid-container');
  if (list) observer.observe(list, { childList: true, subtree: true });
})();
